<template>
  <main class="container is-fluid">
    <template v-if="selectedCorpora.length">
      <div class="columns m-0">
        <div class="column p-0"></div>
        <div class="column p-0 is-narrow">
          <button
            class="button has-text-danger is-pulled-right mb-3"
            v-on:click="clear"
          >
            Unselect all
          </button>
        </div>
      </div>
      <template
        v-for="[corpusId, elements] in selectedCorpora"
        :key="corpusId"
      >
        <CorpusSelection
          :corpus-id="corpusId"
          v-if="elements.length"
        />
        <hr />
      </template>
    </template>
    <div
      v-else
      class="notification is-info"
    >
      Empty selection
    </div>
  </main>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CorpusSelection from '@/components/Navigation/CorpusSelection.vue'
import { useSelectionStore } from '@/stores'

export default defineComponent({
  components: {
    CorpusSelection,
  },
  computed: {
    ...mapState(useSelectionStore, ['count', 'selection']),
    /**
     * Filter corpora to ensure we only display corpora with some selected elements;
     * empty arrays should not matter
     */
    selectedCorpora() {
      return Object.entries(this.selection).filter(([, elements]) => elements?.length)
    },
  },
  methods: {
    ...mapActions(useSelectionStore, ['clear']),
  },
})
</script>
